/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

/**
 *
 * @class PropertiesHolder
 *
 * @brief helper class to carry properties of objects, which be passed around and used throughtout the GUI,
 * without having to know the specific object type and details involves.
 *
 * When tables of the properties are shown, they will be listed in the order they were inserted.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class PropertiesHolder {

  /*
   * note: we assume Map will iterate in the order things were inserted in, so we don't have
   * to sustain an ordering vector on  our own.
   *
   */

  /** our key/value dictionary for properties */
  public properties: Map<string, string> = new Map<string, string>();

  /** header/summary for object */
  public title: string = '';

  /** icon for the object */
  public icon: string = '';

  /** client data (if needed) */
  public context: any;

  /** fetch a property */
  public get(key: string) {

    if (this.properties.has(key)) {

      return this.properties.get(key);
    }

    return '';
  }

  /** set a property */
  public set(key: string, value: string) {

    this.properties.set(key, value);
  }

}
